import { BaseApi } from './base.api.js';

export class ExplicitConsentApi extends BaseApi {
    constructor(client) {
        super(client, '/explicit-consent');
    }
}
